import { FunctionALQuestionnaireModel } from 'libs/questionaire/src/lib/functional/models/questionnaire-functional.model';
import {Product} from '../../../../product/src/lib/models/product.model';
import { UpsPickupReference } from 'libs/tm-common/src/lib/models/ups.model';
import { MichiganSplintQuestionnaireModel } from 'libs/questionaire/src/lib/michigan-splint/models/questionnaire-michigan-splint.model';

// interface to the corresponding Anamnesis schema in database
export interface AnamnesisModel {
	treatment: string;
	questionnaireData: {
		functionAL?: FunctionALQuestionnaireModel,
		michiganSplint?: MichiganSplintQuestionnaireModel,
	}
	releaseData?: ReleaseData,
	lastModified?: Date;
	created?: Date;
	schema_version?: number;
}

export interface Anamnese {
	releaseData?: ReleaseData;
	totalPlannedSteps? : number;
	questionaireAnswers?: object;

	/**@deprecated legacy with 2.1.0 */
	planingFixed?: boolean;
	/**@deprecated */
	product?: Product;  		// product is the last Category which has only one children named 'articles'
	/**@deprecated */
	comments?: any; // legacy unused
	/**@deprecated */
	comment?: string;
	/** @deprecated */
	questionaire?: any;
	/** @deprecated */
	planing?: Planning; //legacy
	/**@deprecated */
	upsPickUpReference?: UpsPickupReference;
	/**@deprecated */
	patientId?: string;
	/**@deprecated legacy with 2.0.0*/
	couponCode?: string;
}

export interface PlanningData {
	totalPlannedSteps?: number;

	/**@deprecated legacy with 2.1.0 */
	planingFixed?: boolean;
	/**@deprecated */
	planing?: Planning; //legacy
}

/**
 * @deprecated
 * Used in mongodb treatments before release 1.10.0
 *
 * From 1.10.0 on, the total amount of steps is saved as 'number'
 */
export interface Planning {
	addCorrections: number;
	alignment: number;
	archDesign: number;
	correction: number;
	occlusion: number;
	spaceManagement: number;
	total: number;
}

/** @deprecated since 2.0.0 */
export interface AnamneseOrder {
	realId: string;
	status: string;
	state: string;
	created: Date;
	anamnese: Anamnese;
}
export interface Comment {
	comment: string;
	date: Date;
	/** @deprecated LEGACY, do not use */
	type?: number;
	/** @deprecated LEGACY, do not use */
	status?: string | number;
}

/** @deprecated LEGACY, do not use */
export enum CommentTypes {
	Customer = 0,
	Technician = 1
}

export interface Release {
	technicianComment?: Comment;
	webViewerUrl?: string;
	webViewerUrlUpgrade?: string;
	/**
	 * ObjectId of the webviewer modification document that should be published
	 * together with the release request. Set when the technician opts to include
	 * the modification for the primary webviewer (`webViewerUrl`).
	 */
	webViewerModification?: string;
	/**
	 * ObjectId of the webviewer modification document for the alternative option.
	 * Analogous to `webViewerModification` but tied to `webViewerUrlUpgrade`.
	 */
	webViewerAlternativeOptionModification?: string;

	/** @deprecated LEGACY, do not use. */
	onyxPwd?: string;
	/** @deprecated LEGACY, do not use. */
	onyxUrl?: string;
}

export interface ReleaseFile {
	name: string;
	id: string;
}

export interface ReleaseData {
	release?: Release;
	releaseFiles?: ReleaseFile[];
	releaseUpdatedAt?: Date | string;

	/** @deprecated legacy with 2.3.0 */
	releaseFixed?: boolean;
	/** @deprecated LEGACY, do not use. */
	upgrade?: boolean; // XXX somewhat redundant. true, if treatment.upgrade exists.

	/** @deprecated LEGACY, do not use. */
	releaseRequestedAt?: Date | string;

	/** @deprecated LEGACY, do not use. */
	comments?: Comment[];

	/** @deprecated LEGACY, do not use. */
	orderZielmodel?: boolean;
}
